// extracted by mini-css-extract-plugin
module.exports = {"category":"top-talent-category-table_category__3IpKN","textField":"top-talent-category-table_textField__2gAvN","editInput":"top-talent-category-table_editInput__30MWJ"};